import angular from 'angular';
import ngRedux from 'ng-redux';
import { configureStore } from './store';
import { extensionsStoreWatch, messagesStoreWatch, } from '../modules/extensions-framework';
import { applySubscriptionIntegrations } from '../modules/extensions-framework/angular-integration/subscriptions-integration';
import { applyAngularServicesIntegrations } from '../modules/extensions-framework/angular-integration/services-integration';
import * as devices from '../modules/devices';
export default angular
    .module('doxy.redux', [ngRedux])
    .config(($ngReduxProvider) => {
    $ngReduxProvider.config.debounce = {
        wait: 100,
        maxWait: 500,
    };
    $ngReduxProvider.provideStore(configureStore());
    messagesStoreWatch();
    extensionsStoreWatch();
    applySubscriptionIntegrations();
    applyAngularServicesIntegrations();
})
    .run(($ngRedux) => {
    // todo: move it to right place, maybe App component or some other general place for initial actions
    $ngRedux.dispatch(devices.actions.devicesInitAction());
});
